//src/router/index.js
import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

import { loginRoute, loginTokenRoute } from "./login/routesLogin";

import { homeList } from "./admin/home/routesHome";
import { recognizeList } from "./admin/recognize/routesRecognize";
import { newsList, intraNewsList } from "./admin/news/routesNews";
import { benefitList } from "./admin/benefit/routesBenefit";

import { birthdayList } from "./admin/birthday/routesBirthday";
import { covidList } from "./admin/covid/routesCovid";
import { cultureList } from "./admin/culture/routesCulture";
import { galleryList } from "./admin/gallery/routesGallery";
import { libraryList } from "./admin/library/routesLibrary";

import { organigramaList } from "./admin/organigrama/routesOrganigrama";
import { seguridadList } from "./admin/seguridad/routesSeguridad";
import { videosList } from "./admin/video/routesVideo";
import { profileList } from "./profile/routesProfile";

import { userList } from "./admin/users/routesUsers";
import { alertPushList } from "./admin/alertaPush/routesAlert";
import { encuestasList } from "./admin/encuestas/routesEncuestas";
import { transporteList } from "./admin/transporte/routesTransporte";
import { wallList } from "./admin/wall/routesWall";

import { births } from "@/router/admin/births/routesBirths";
import { customization } from "@/router/admin/customization/routesCustomization";

import { canalCorporativoList } from "./admin/tv/routesTV";
import { hotelsList } from "./admin/hotels/routesHotels";
import { mails } from "./admin/mail/routesMail";
import { eppList } from "./admin/epp/routesEpp";

import { qrList } from "./admin/qr/routesQr";

Vue.use(VueRouter);

const getStoredValue = (key) => {
  const raw = localStorage.getItem(`vuejs__${key}`);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed?.value ?? null;
  } catch (error) {
    console.warn(`No se pudo parsear ${key} desde localStorage`, error);
    return null;
  }
};

const loadModulesForRedirect = async () => {
  const modulesFromStore = store.state.sidebar?.modules;

  
  if (modulesFromStore && modulesFromStore.length) return modulesFromStore;

  const modulesFromLs = getStoredValue("modulos");
  if (Array.isArray(modulesFromLs) && modulesFromLs.length) return modulesFromLs;

  const user = getStoredValue("user");
  if (!user) return [];

  const empresa = user.empresa?.[0];
  const privilegio = user.privilegio?.[0];
  const grupo = user.grupo?.[0];

  if (!empresa || !privilegio) return [];

  const payload = {
    id_privilegio: privilegio.id_tipo,
    id_grupo:
      user.grupo != null && typeof grupo === "object" && grupo != null
        ? grupo.id_grupo
        : "null",
  };

  try {
    const response = await store.dispatch("sidebar/getModules", payload);
    if (Array.isArray(response) && response.length) return response;
    const refreshed = store.state.sidebar?.modules;
    if (refreshed && refreshed.length) return refreshed;
  } catch (error) {
    console.warn("No se pudieron cargar módulos para redirección", error);
  }

  return [];
};

const redirectWithModules = (modules, next) => {
  if (!Array.isArray(modules) || !modules.length) {
    next({ name: "Inicio" });
    return;
  }
  if (modules.some((module) => module.moduloGeneral?.id_modulo === "1")) {
    next({ name: "Inicio" });
    return;
  }
  if (modules.some((module) => module.moduloGeneral?.id_modulo === "24")) {
    next({ path: "/CanalCorporativo" });
    return;
  }

  next({ path: modules[0].moduloGeneral.ruta_admin });
};

const routes = [
  {
    path: "*",
    beforeEnter: async (to, from, next) => {
      const modules = await loadModulesForRedirect();
      redirectWithModules(modules, next);
    },
  },
  hotelsList,
  benefitList,
  birthdayList,
  covidList,
  cultureList,
  galleryList,
  homeList,
  libraryList,
  newsList,
  intraNewsList,

  organigramaList,
  recognizeList,
  seguridadList,
  videosList,
  loginRoute,
  loginTokenRoute,
  profileList,

  userList,
  alertPushList,
  encuestasList,
  transporteList,
  wallList,
  canalCorporativoList,
  mails,
  eppList,
  qrList,
  //FF
  births,
  customization,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const accessToken = localStorage.getItem("access-token");
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth);

  if (requiresAuth && !accessToken) {
    next({ name: "Login" });
    return;
  }

  if (accessToken && (to.name === "Login" || to.name === "Login-token")) {
    const modules = await loadModulesForRedirect();
    redirectWithModules(modules, next);
    return;
  }

  next();
});

export default router;
